import { makeAutoObservable } from 'mobx';
import { WebsocketV1 } from 'src/AppState/websocketV1/WebsocketV1';
import { Common } from 'src/AppState/Common';
import { CompetitionStoreState } from './BetTickerBox/BetTickerForm/CompetitionPicker/CompetitionStore.state';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { SdkStaff, SportsListType } from 'src/AppState/sdk/staff';
import { Resource } from 'src_common/common/mobx-utils/Resource';

export class BetTickerV2State {
    public betsData: Array<Object>;
    public settledBetsData: Array<Object>;
    public rejectedBetsData: Array<Object>;
    public readonly allSports: Resource<SportsListType>;
    public readonly competitionStore: AutoMap<string, CompetitionStoreState>;

    private readonly webSocketV1: WebsocketV1;
    private readonly betTopic = 'staff:BetPlace';
    private readonly betSettledTopic = 'staff:BetSettled';
    private readonly rejectedBetTopic = 'staff:RejectedBet';
    public constructor(
        private common: Common,
        sdkStaff: SdkStaff
    ) {
        this.webSocketV1 = WebsocketV1.get(this.common);
        this.betsData = [];
        this.settledBetsData = [];
        this.rejectedBetsData = [];
        this.competitionStore = new AutoMap((sportId: string) => {
            return new CompetitionStoreState(common, sportId);
        });
        this.allSports = new Resource(async () => await sdkStaff.getAllSports());

        makeAutoObservable(this);
    }

    private handleSocketMessageBets = (data: unknown): void => {
        if (typeof data === 'object' && data !== null) this.betsData.push(data);
    };

    private handleSocketMessageSettledBets = (data: unknown): void => {
        if (typeof data === 'object' && data !== null) this.settledBetsData.push(data);
    };

    private handleSocketMessageRejectedBets = (data: unknown): void => {
        if (typeof data === 'object' && data !== null) this.rejectedBetsData.push(data);
    };

    public subscribeToBets(): void {
        this.webSocketV1.subscribe(this.betTopic, this.handleSocketMessageBets);
    }

    public subscribeToRejectedBets(): void {
        this.webSocketV1.subscribe(this.rejectedBetTopic, this.handleSocketMessageRejectedBets);
    }

    public subscribeToSettledBets(): void {
        this.webSocketV1.subscribe(this.betSettledTopic, this.handleSocketMessageSettledBets);
    }

    public unsubscribeFromBets(): void {
        this.webSocketV1.unsubscribe(this.betTopic, this.handleSocketMessageBets);
    }

    public unsubscribeFromRejectedBets(): void {
        this.webSocketV1.unsubscribe(this.rejectedBetTopic, this.handleSocketMessageRejectedBets);
    }

    public unsubscribeFromSettledBets(): void {
        this.webSocketV1.unsubscribe(this.betSettledTopic, this.handleSocketMessageSettledBets);
    }
}
